/*
 * @Description:
 */
import plusReady from './h5-plusready'

let backbuttonRoute = null
const handleBackbutton = () => {
  plusReady.h5BackPrep(backbuttonRoute)
}

const removeBackbuttonListener = () => {
  if (!window.plus) return
  window.plus.key.removeEventListener('backbutton', handleBackbutton)
  backbuttonRoute = null
}

const h5HandlePlusready = function (route) {
  // ios禁止右滑
  window.plus.webview.currentWebview().setStyle({ popGesture: 'none' })
  // 设置系统状态栏背景颜色
  // window.plus.navigator.setStatusBarBackground('#ffffff')
  // 设置系统状态栏样式
  window.plus.navigator.setStatusBarStyle('dark')
  // 返回键监听只保留一个实例，避免 App 重复初始化时叠加
  removeBackbuttonListener()
  backbuttonRoute = route
  window.plus.key.addEventListener('backbutton', handleBackbutton)
  // 设置安全区
  const statusbarHeight = window.plus.navigator.getStatusbarHeight()
  // const scale = window.plus.screen.scale

  document.documentElement.style.setProperty('--status-bar-height', statusbarHeight + 'px')
}

export default {
  h5HandlePlusready,
  removeBackbuttonListener
}
